export default __webpack_public_path__ + "static/media/tutorial1-3.950f70fd.png";